export default {
  placeholder (h, conf, key) {
    // return <template slot="placeholder">{conf.__slot__[key]}</template>
    const list = []
    list.push(
      <template slot="placeholder">
        <el-skeleton>
          <template slot="template">
            <el-skeleton-item variant="image" style="height: 300px; background: transparent" />
          </template>
        </el-skeleton>
      </template>
    )
    return list
  },
  error (h, conf, key) {
    const val = String(conf.__slot__[key])
    if (val && val.includes('el-icon')) {
      return <div class="image-slot-error" slot="error"><i class={conf.__slot__[key]}></i></div>
    } else {
      return <div class="image-slot-error" slot="error">{conf.__slot__[key]}</div>
    }
  }
}
